import { render, staticRenderFns } from "./ScreenDialog.vue?vue&type=template&id=6b87a0d9&scoped=true"
import script from "./ScreenDialog.vue?vue&type=script&lang=js"
export * from "./ScreenDialog.vue?vue&type=script&lang=js"
import style0 from "./ScreenDialog.vue?vue&type=style&index=0&id=6b87a0d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87a0d9",
  null
  
)

export default component.exports